export enum Checked {
    Nok,
    Ok,
    Locked,
}
